const NCB_CONFIG = {
  instance: '56134_cp_stweardship',
  secretKey: '1e333a174cf2bf54a849637a9bad12e8d3fcb5716a23f0c0bc7841a99a09',
  dataUrl: 'https://app.nocodebackend.com/api/data',
};

export async function writeFetch(path, options = {}) {
  const separator = path.includes('?') ? '&' : '?';
  const url = `${NCB_CONFIG.dataUrl}/${path}${separator}Instance=${NCB_CONFIG.instance}`;

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${NCB_CONFIG.secretKey}`,
        'X-Database-Instance': NCB_CONFIG.instance,
        ...(options.headers || {}),
      }
    });

    // If NoCodeBackend rejects the payload, throw an error to catch it
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`❌ NCB API Error (${response.status}):`, errorText);
      throw new Error(`NCB Error ${response.status}: ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('❌ writeFetch Error:', error);
    throw error;
  }
}